import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'floPricePeriod' })
export class FloPricePeriodPipe implements PipeTransform {
  transform(yearly: boolean, displayPriceYearly: boolean): 'yr' | 'mo' {
    return yearly && displayPriceYearly ? 'yr' : 'mo'
  }
}
